/*@ngInject*/
const JavaScriptExpressionController = function ($rootScope, $scope, $state, $stateParams, $timeout, localization, coreConstant, configurationConstant, configurationActionsUtil, formViewerConstant, configurationMediator, fieldTemplate, expressionName, expressionValue, javascriptApplicableExpressions, javascriptExpressionType) {

    var timeoutList = [],
        translations;

    $scope.expressionViewModel = {
        title: '',
        okButton: '',
        cancelButton: '',
        saveButton: '',
        functionPlaceholder: '',
        valueFormat: fieldTemplate.valueFormat,
        addToScriptEnabled: false,
        fieldMuliSelectEnabled: true,
        fieldSelectorEnabled: true,
        isChanged: false,
        hasError: false
    };

    $scope.uiFormTemplate = null;
    $scope.jsBuilderOptions = null;
    $scope.fieldTemplate = fieldTemplate;
    $scope.expressionName = expressionName;
    $scope.expessionValue = expressionValue;

    $scope.fields = [];

    function init() {
        localization.getTranslationsByKeys(['jsExpression']).then(function (result) {
            translations = result;
            $scope.expressionViewModel.title = translations[$scope.expressionName] + translations.title + $scope.fieldTemplate.variableName;
            $scope.expressionViewModel.okButton = translations['confirmButtonLabel'];
            $scope.expressionViewModel.cancelButton = translations['cancelButtonLabel'];
            $scope.expressionViewModel.saveButton = translations['saveButtonLabel'];
            $scope.expressionViewModel.functionPlaceholder = translations['functionPlaceholder'];
            $scope.expressionViewModel.editorPlaceholder = translations['editorPlaceholder'];
        });

        configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (uiFormTemplate) {
            $scope.uiFormTemplate = uiFormTemplate;
            addField();
        });


        configurationMediator.getJsBuilderOptions($stateParams.uiFormTemplateId).then(function (jsBuliderOptions) {
            if ($scope.expressionName === 'disableExpressions') {
                _.remove(jsBuliderOptions, {applicableExpressions: javascriptApplicableExpressions.REQUIRED_EXPRESSION});
            } else if ($scope.expressionName === 'requiredLevelExpression') {
                _.remove(jsBuliderOptions, {applicableExpressions: javascriptApplicableExpressions.DISABLE_EXPRESSION});
            } else {
                _.remove(jsBuliderOptions, {applicableExpressions: javascriptApplicableExpressions.REQUIRED_EXPRESSION});
                _.remove(jsBuliderOptions, {applicableExpressions: javascriptApplicableExpressions.DISABLE_EXPRESSION});
            }
            $scope.functionList = jsBuliderOptions;
        });
    }

    function addField() {
        $scope.fields.push({'item1Name': $scope.uiFormTemplate.formTemplate.uniqueName, 'item2Name': ''});
    }

    function resetInputs() {
        $scope.selectedFunction = undefined;
        $scope.expressionViewModel.selectedFunction = $scope.selectedFunction;
        $scope.fields = [];
        addField();
        $scope.expressionViewModel.addToScriptEnabled = false;
    }

    function removeField(index) {
        $scope.fields.splice(index, 1);
    }

    function checkEditorPlaceHolder() {
        var shouldShow = !$scope.editor.session.getValue().length;
        var node = $scope.editor.renderer.emptyMessageNode;
        if (!shouldShow && node) {
            $scope.editor.renderer.scroller.removeChild($scope.editor.renderer.emptyMessageNode);
            $scope.editor.renderer.emptyMessageNode = null;
        } else if (shouldShow && !node) {
            node = $scope.editor.renderer.emptyMessageNode = document.createElement('div');
            node.textContent = $scope.expressionViewModel.editorPlaceholder;
            node.className = 'ace_invisible ace_emptyMessage';
            node.style.padding = '0 9px';
            $scope.editor.renderer.scroller.appendChild(node);
        }
    }

    function updateFieldTemplate() {
        var expression = $scope.editor.getValue();

        if ($scope.isActive('valueExpression')) {
            $scope.fieldTemplate.valueFormat = $scope.expressionViewModel.valueFormat;
        }

        $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
            name: $scope.expressionName,
            value: expression
        });
    }

    function saveFormTemplate() {
        var saveAs = false;
        configurationActionsUtil.saveUiFormTemplate($scope.uiFormTemplate.id, saveAs);
    }

    $scope.onSave = function () {
        updateFieldTemplate();
        saveFormTemplate();
    };

    $scope.onSaveAndClose = function () {
        $scope.onSave();
        $scope.$dismiss();
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.isActive = function (buttonName) {
        return buttonName.indexOf($scope.expressionName) >= 0;
    };

    $scope.onAceLoaded = function (editor) {
        $scope.editor = editor;

        ace.config.set('basePath', 'js/ace');

        $scope.editor.session.setMode('ace/mode/javascript');
        $scope.editor.setTheme('ace/theme/chrome');
        $scope.editor.session.setUseWrapMode(true);
        $scope.editor.setShowPrintMargin(false);
        $scope.editor.$blockScrolling = Infinity;

        $scope.editor.session.on('changeAnnotation', $scope.onSessionAnnotationChange);
        $scope.editor.session.on('change', $scope.onSessionEditorChange);

        if ($scope.expessionValue) {
            $scope.editor.setValue($scope.expessionValue);
            $scope.editor.clearSelection();
        }
        checkEditorPlaceHolder();

    };

    $scope.onSessionAnnotationChange = function () {
        var hasError, hasChange = false;
        var annotations = [];
        _.each($scope.editor.session.getAnnotations(), function (annotation) {
            if (annotation.type === 'error') {
                hasError = true;
            }
            if (annotation.type === 'warning' &&
                (annotation.text.indexOf('!==')>0 || annotation.text.indexOf('===')>0) ) {
                // '!==' and '===' doesn't work with current JS engine
                hasChange = true;
            }
            else {
                annotations.push(annotation);
            }
        });
        if (hasChange) {
            $scope.editor.session.setAnnotations(annotations);
        }

        if ($scope.expressionViewModel.hasError !== hasError) {
            $scope.expressionViewModel.hasError = hasError;
            $timeout(function () {
            }, 0);
        }
    };

    $scope.onSessionEditorChange = function () {
        if ($scope.expressionViewModel.isChanged !== true) {
            $scope.expressionViewModel.isChanged = true;
            $timeout(function () {
            }, 0);
        }
        checkEditorPlaceHolder();
    };

    $scope.onValueFormatChange = function () {
        $scope.expressionViewModel.isChanged = true;
    };

    function splitFields(fieldNamesConcat) {
        var fieldNames = [];
        if (fieldNamesConcat) {
            fieldNames = _.split(fieldNamesConcat, ', ');
        }

        return fieldNames;
    }

    function getFieldNames() {
        var fieldNames = [];
        _.each($scope.fields, function (field, index) {
            if (field.item2Name !== null && field.item2Name !== '') {
                var names = splitFields(field.item2Name);
                _.each(names, function (name) {
                    var fieldFullName = name;
                    if ($scope.uiFormTemplate.formTemplate.uniqueName !== field.item1Name) {
                        fieldFullName = $scope.fields[index].item1Name + '::' + name;
                    }
                    fieldNames.push(fieldFullName);
                });
            }
        });
        return fieldNames;
    }

    function checkActionButtons() {
        var fieldCount = getFieldNames().length;
        $scope.expressionViewModel.fieldSelectorEnabled = true;
        $scope.expressionViewModel.fieldMuliSelectEnabled = true;
        if ($scope.selectedFunction && $scope.selectedFunction.type === 'function') {
            if ($scope.selectedFunction.group === 'Field Functions') {
                $scope.expressionViewModel.addToScriptEnabled = fieldCount > 0;
            }
            else {
                $scope.expressionViewModel.addToScriptEnabled = true;
            }
            if ($scope.selectedFunction.operandCount === '1' || $scope.selectedFunction.operandCount === 'Exactly 1') {
                $scope.expressionViewModel.fieldMuliSelectEnabled = false;
                if ($scope.fields.length > 1) {
                    $scope.fields = $scope.fields.slice(0, 1);
                }
            }
        }
        else if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.CONSTANT) {
            $scope.expressionViewModel.addToScriptEnabled = true;
            $scope.expressionViewModel.fieldSelectorEnabled = false;
        }
        else if ($scope.selectedFunction || fieldCount > 0) {
            if ($scope.selectedFunction && $scope.selectedFunction.operandCount === '2+' && fieldCount < 2) {
                $scope.expressionViewModel.addToScriptEnabled = false;
            }
            else {
                $scope.expressionViewModel.addToScriptEnabled = true;
            }
        }
        else {
            $scope.expressionViewModel.addToScriptEnabled = false;
        }

        // switching from single field to multiple, need to add new field selector
        if ($scope.expressionViewModel.fieldMuliSelectEnabled && $scope.fields.length === 1 && $scope.fields[0].item2Name) {
            addField();
        }
        ;
    }

    $scope.onSelectFunction = function (value) {
        $scope.selectedFunction = value;
        $scope.expressionViewModel.selectedFunction = $scope.selectedFunction;
        if (value) {
            $scope.selectedFunction.description = translations.functions[$scope.selectedFunction.value];
        }
        checkActionButtons();
    };

    $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2, isMultiSelect) {
        var item2Name = '';

        var index = event.targetScope.$parent.$index;

        if (isMultiSelect) {
            item2Name = item2;
        } else {
            if (item2.propertyName) {
                item2Name = item2.propertyName;
            } else {
                item2Name = item2.fieldName;
            }
        }
        $scope.fields[index].item1Name = item1Name;
        $scope.fields[index].item2Name = item2Name;

        if ($scope.fields.length !== index + 1 && !item1Name && !item2Name) {
            removeField(index);
        }
        else if ($scope.fields.length === index + 1 && item1Name && item2Name && $scope.fields.length < 5) {
            addField();
        }

        checkActionButtons();
    });

    $scope.$on(configurationConstant.event.FORM_COMPONENT_SELECTED, function (event) {
        var index = event.targetScope.$parent.$index; // todo refactor this
        $scope.fields[index].item2Name = event.targetScope.$ctrl.selectedStep2ItemName;
        checkActionButtons();
    });

    $scope.onAddToScript = function () {
        var fieldNames = getFieldNames(),
            fieldCount = fieldNames.length,
            useArray,
            fieldFunction = 'fieldValue';

        if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.FUNCTION && $scope.selectedFunction.group === 'Field Functions') {
            fieldFunction = $scope.selectedFunction.value;
        }
        if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.FUNCTION && $scope.selectedFunction.group !== 'Field Functions') {
            $scope.editor.insert($scope.selectedFunction.value + '(');
        }
        if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.CONSTANT) {
            $scope.editor.insert($scope.selectedFunction.value);
            fieldCount = 0;
        }

        // insert text for the fields
        useArray = false;
        if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.FUNCTION && $scope.selectedFunction.group !== 'Field Functions') {
            if ($scope.selectedFunction.operandCount === '1' || $scope.selectedFunction.operandCount === 'Exactly 1') {
                if (fieldCount > 1) {
                    fieldCount = 1;
                }
            }
            else if (fieldCount===1) {
                fieldFunction = 'fieldValues';
            }
            else {
                useArray = true;
            }
        }
        if (useArray) {
            $scope.editor.insert('[');
        }
        for (var i = 0; i < fieldCount; i++) {
            $scope.editor.insert(fieldFunction + '("' + fieldNames[i] + '")');
            if (i < (fieldCount - 1)) {
                if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.OPERATOR) {
                    $scope.editor.insert(' ' + $scope.selectedFunction.value + ' ');
                }
                else {
                    $scope.editor.insert(', ');
                }
            }
        }
        if (useArray) {
            $scope.editor.insert(']');
        }

        if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.FUNCTION && $scope.selectedFunction.group !== 'Field Functions') {
            $scope.editor.insert(')');
        }

        $scope.expressionViewModel.isChanged = true;

        resetInputs();
    };

    $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function (event) {
        $scope.$dismiss();
    });

    $scope.$on('$destroy', function () {
        $scope.editor.session.off('changeAnnotation', $scope.onSessionAnnotationChange);
        $scope.editor.session.off('change', $scope.onSessionEditorChange);
        $scope.editor = null;

        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    init();
};

angular.module('umCore')
    .controller('javaScriptExpressionController', JavaScriptExpressionController);
